import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "handDollar"
const HandDollarIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M6 14.526C6.678 14.526 7.25 14.976 7.436 15.594L8.781 14.922C9.301 14.662 9.876 14.526 10.458 14.526H12C13.35 14.526 14.492 15.418 14.868 16.645L17.903 14.938C18.938 14.356 20.248 14.67 20.906 15.659 21.524 16.585 21.378 17.824 20.562 18.581L17.918 21.037C16.714 22.155 15.131 22.777 13.488 22.777H12.566C11.614 22.776 10.668 22.621 9.765 22.32L7.472 21.557C7.341 22.25 6.732 22.777 6 22.777H4.5C3.672 22.776 3 22.104 3 21.276V16.026C3 15.196 3.672 14.526 4.5 14.526zM4.5 21.276H6V16.026H4.5zM10.458 16.026C10.11 16.026 9.764 16.107 9.452 16.263L7.5 17.24V19.986L10.239 20.898C10.989 21.148 11.775 21.276 12.566 21.276H13.488C14.753 21.276 15.97 20.798 16.897 19.937L19.541 17.482C19.818 17.225 19.868 16.805 19.658 16.491 19.435 16.155 18.99 16.048 18.638 16.246L15.19 18.186C14.21 18.736 13.106 19.026 11.983 19.026H11.625C11.211 19.026 10.875 18.69 10.875 18.276S11.211 17.526 11.625 17.526H11.983C12.493 17.526 12.997 17.446 13.48 17.296 13.37 16.575 12.75 16.025 12 16.025z"
            clipRule="evenodd"
          />
          <path d="M12.614 4.906C13.058 4.97 13.518 5.153 13.898 5.432L13.38 6.192C13.075 5.983 12.662 5.823 12.186 5.822 11.661 5.823 11.354 6.047 11.354 6.335 11.354 7.037 14.019 6.798 14.019 8.57 14.02 9.304 13.462 9.91 12.614 10.086V10.933H11.644V10.103C11.08 10.014 10.442 9.758 9.982 9.311L10.602 8.626C10.99 8.945 11.483 9.176 12.081 9.176 12.63 9.177 12.929 8.906 12.929 8.587 12.929 7.683 10.264 8.065 10.263 6.325 10.263 5.505 10.91 5.059 11.645 4.915V4.067H12.614z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C15.314 1.5 18 4.186 18 7.5S15.314 13.5 12 13.5 6 10.814 6 7.5 8.686 1.5 12 1.5M12 3C9.515 3 7.5 5.015 7.5 7.5S9.515 12 12 12 16.5 9.985 16.5 7.5 14.485 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default HandDollarIcon
